import Marquee from "react-fast-marquee";
import { TriangleAlert } from "lucide-react";

export default function MarqueeBanner() {
  const items = Array.from({ length: 6 });
  return (
    <div
      data-testid="marquee-banner"
      className="w-full bg-[#facc15] border-y-[3px] border-black overflow-hidden"
    >
      <Marquee speed={60} gradient={false} pauseOnHover={true}>
        {items.map((_, i) => (
          <span key={i} className="font-mono-ui font-bold text-black text-sm md:text-base flex items-center gap-3 mx-6 py-2">
            <TriangleAlert className="w-4 h-4" strokeWidth={3} />
            FOR RESEARCH USE ONLY — NOT FOR HUMAN CONSUMPTION
            <span className="text-[#ff1493]">●</span>
            FREE UK POSTAGE ON ORDERS OVER £100
            <TriangleAlert className="w-4 h-4" strokeWidth={3} />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
